import { Component, h } from '@stencil/core';
import { orderFields } from '../../store/order-fields.store';
import { checkout } from '../../store/checkout.store';
import { renderOrderFields } from '../../utils/form';

@Component({
  tag: 'tambr-order-fields',
  styleUrl: 'tambr-order-fields.css',
  shadow: true,
})
export class TambrOrderFields {
  
  render() {
    if ( orderFields.orderFieldsLoading ) {
      return <div class='order-details'>
        <tambr-loading-spinner />
      </div>;
    }
    if ( !orderFields.customFields?.length ) return;
    return ([
      this.renderErrorMessages(),
      <div class='order-details'>
        { renderOrderFields( checkout.customFieldsForm ) }
      </div>
    ]);
  }

  renderErrorMessages() {
    if ( !checkout.customFieldsFormErrors.length ) return;
    console.log(checkout.customFieldsFormErrors);
    return (
      <ul class='custom-fields-errors'>
        { checkout.customFieldsFormErrors.map( message => <li class='custom-field-error'>{ message }</li> ) }
      </ul>
    );
  }
}
